import {CardReorderReason} from '../dto/card-reorder-reason';

export class CardReorderModel {
    public id: number;
    public reason: CardReorderReason;
    public comment: string;
}

export class CardExtensionModel {
  public publicToken: string;
}
